import styles from './product-structure-grid-cell-renderer.module.scss';
import { ValueFormatterParams } from 'ag-grid-community';
import { useState } from 'react';
import { Col, Row } from 'reactstrap';
import { Container, CreateHeaders, GrayOutlinedButton, HeaderSizeEnum, textHeader } from '@frontend-workspace/react-shared-lib';
import DeleteSubmoduleDialog from '../delete-submodule-dialog/delete-submodule-dialog';
import DeleteRelatedProductDialog from '../delete-related-product-dialog/delete-related-product-dialog';
import { WebkuaTable } from '@frontend-workspace/webkua-lib';
import { useTranslation } from 'react-i18next';

/* eslint-disable-next-line */
export interface ProductStructureListDetailsGridCellRendererProps { }

export function ProductStructureListDetailsGridCellRenderer(props: any) {
  const { t } = useTranslation();
  const [deleteSubmodule, setDeleteSubmodule] = useState<undefined>();
  const [deleteRelatedProduct, setDeleteRelatedProduct] = useState<undefined>();

  const openDeleteSubmoduleDialog = (e: any) => setDeleteSubmodule(e.data);
  const closeDeleteSubmoduleDialog = () => setDeleteSubmodule(undefined);
  const openDeleteRelatedProductDialog = (e: any) => setDeleteRelatedProduct(e.data);
  const closeDeleteRelatedProductDialog = () => setDeleteRelatedProduct(undefined);

  const deleteSubmoduleRenderer = (params: ValueFormatterParams) => (
    <GrayOutlinedButton
      variant="outlined"
      size='small'
      onClick={() => openDeleteSubmoduleDialog(params)}>
      {t("standard.delete")}
    </GrayOutlinedButton>
  );

  const deleteRelatedProductRenderer = (params: ValueFormatterParams) => (
    <GrayOutlinedButton
      variant="outlined"
      size='small'
      onClick={() => openDeleteRelatedProductDialog(params)}>
      {t("standard.delete")}
    </GrayOutlinedButton>
  );

  return <>
    {props.data.productName &&
      <Container>
        <Row>
          <Col>
            <div className="d-flex flex-column py-4 px-2">
              <WebkuaTable
                headers={CreateHeaders([
                  textHeader("", t("standard.submodules"), HeaderSizeEnum.LARGE),
                  textHeader("", "", HeaderSizeEnum.SMALL, { renderer: deleteSubmoduleRenderer })
                ])}
                data={props.data.productName}
              />
            </div>
          </Col>
          <Col>
            <div className="d-flex flex-column py-4 px-2">
              <WebkuaTable
                headers={CreateHeaders([
                  textHeader("", t("standard.systemRelatedProducts")),
                  textHeader("", "", HeaderSizeEnum.SMALL, { renderer: deleteRelatedProductRenderer })
                ])}
                data={props.data.productName}
              />
            </div>
          </Col>
        </Row>
      </Container>
    }
    <DeleteSubmoduleDialog
      open={!!deleteSubmodule}
      onClose={closeDeleteSubmoduleDialog}
      deleteSubmodule={deleteSubmodule}
    />
    <DeleteRelatedProductDialog
      open={!!deleteRelatedProduct}
      onClose={closeDeleteRelatedProductDialog}
      deleteRelatedProduct={deleteRelatedProduct}
    />
  </>;
}

export default ProductStructureListDetailsGridCellRenderer;